/**
 * @author xyguo
 * @description 新开业培训要求管理
 * @Date 2021/3/11
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterType = (val) => {
  let newVal;
  switch (val){
    case  1 : newVal ='经销商'
      break;
    case  2 : newVal ='服务商'
      break;
    case  99 : newVal = '暂定'
      break;
    default :  newVal = '无';
  }
  return newVal;
}

class DealerNewPersonTrainList extends WizContainer {

  componentName = 'DealerNewPersonTrainList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '经销商名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '销售代码',
        field: 'preSalesNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '售后代码',
        field: 'afterSalesNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '站点类型',
        field: 'typeCh',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '开店状态',
        field: 'stateCh',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '开店时间',
        field: 'openTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '新店/老店',
        field: 'oldNewShopCh',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: 'DP状态未确认人数',
        field: 'dpNum',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['openTime'] = formatterDate(e['openTime']);
        e['dealerOpenTime'] = formatterDate(e['dealerOpenTime']);
        e['completeTime'] = formatterMinute(e['completeTime']);
        e['type'] =  formatterType(e['type']);
      })
      WizBrowserExport({
        title: '经销商新人培训',
        sheetName: '经销商新人培训',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '经销商新人培训.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        updateState: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(DealerNewPersonTrainList);
